import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../helpers/api_helper';

export interface CreateGameRatePayload {
  game_name: string;
  display_ratio: number;
  is_active: boolean;
}

export interface GameRatio {
  id: number;
  game_name: string;
  display_ratio: number;
  ratio_text: string;
  is_active: boolean;
}

export interface CreateGameRateResponse {
  success: boolean;
  message: string;
  game_ratio: GameRatio;
}

export interface GameRateState {
  createGameRateLoading: boolean;
  createGameRateError: string | null;
  lastCreatedGameRate: CreateGameRateResponse | null;
}

const initialState: GameRateState = {
  createGameRateLoading: false,
  createGameRateError: null,
  lastCreatedGameRate: null,
};

// Async thunk for creating game rate
export const createGameRate = createAsyncThunk(
  'gameRate/createGameRate',
  async (payload: CreateGameRatePayload, { rejectWithValue }) => {
    try {
      const response = await api.post('/admin/game-ratios/', payload);
      return response.data as CreateGameRateResponse;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 
        error.response?.data?.error || 
        'Failed to create game rate'
      );
    }
  }
);

const gameRateSlice = createSlice({
  name: 'gameRate',
  initialState,
  reducers: {
    clearCreateGameRateError: (state) => {
      state.createGameRateError = null;
    },
    clearLastCreatedGameRate: (state) => {
      state.lastCreatedGameRate = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createGameRate.pending, (state) => {
        state.createGameRateLoading = true;
        state.createGameRateError = null;
      })
      .addCase(createGameRate.fulfilled, (state, action) => {
        state.createGameRateLoading = false;
        state.lastCreatedGameRate = action.payload;
      })
      .addCase(createGameRate.rejected, (state, action) => {
        state.createGameRateLoading = false;
        state.createGameRateError = action.payload as string;
      });
  },
});

export const { clearCreateGameRateError, clearLastCreatedGameRate } = gameRateSlice.actions;
export default gameRateSlice.reducer;

